import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class UserContactInfo extends Component {
    
    constructor ( props ) {
        super( props );
        this.state = {
            user: null
        };
      }

      async componentWillMount() {
          if (this.props.user != null){
            this.setState({user: this.props.user});
          }
    }

    render () {
        const user = this.props;
        const name = `${user.FirstName} ${user.LastName}`;
        
        // Handle both string and array formats for experiences
        let careerExperiences = [];
        if (user.CareerExperiences) {
            if (typeof user.CareerExperiences === 'string') {
                careerExperiences = user.CareerExperiences.split(',');
            } else if (Array.isArray(user.CareerExperiences)) {
                careerExperiences = user.CareerExperiences;
            }
        }
        
        // Handle singular/plural naming and both formats
        let industryExperiences = [];
        const industryData = user.IndustryExperiences || user.IndustryExperience;
        if (industryData) {
            if (typeof industryData === 'string') {
                industryExperiences = industryData.split(',');
            } else if (Array.isArray(industryData)) {
                industryExperiences = industryData;
            }
        }

        const careerExperienceList = careerExperiences.map((item, index) => {
            const displayValue = typeof item === 'object' ? (item.name || item.id || JSON.stringify(item)) : item;
            return <li key={`career-${index}`}>{displayValue}</li>
        });

        const industryExperienceList = industryExperiences.map((item, index) => {
            const displayValue = typeof item === 'object' ? (item.name || item.id || JSON.stringify(item)) : item;
            return <li key={`industry-${index}`}>{displayValue}</li>
        });

        return (
            <div className="user-contact-info" key={`user-contact-info-key-${user.UserId || 'unknown'}`}>
                { !!name && name !== ''
                    ? (
                        <address>
                            <strong>Name</strong>
                            <br />
                            <span className="name">{ name }</span>
                        </address>
                    ) : null
                }                
                { careerExperienceList.length > 0
                    ? (
                        <div>
                            <strong>Career Experiences</strong>
                            <ul>{ careerExperienceList }</ul>
                        </div>
                    ) : null
                }
                { industryExperienceList.length > 0
                    ? (
                        <div>
                            <strong>Industry Experiences</strong>
                            <ul>{ industryExperienceList }</ul>
                        </div>
                    ) : null
                }
            </div>
        );
    }
}

UserContactInfo.propTypes = {
    UserId: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ])
    , FirstName: PropTypes.string
    , LastName: PropTypes.string
    , EmailAddress: PropTypes.string
    , Phone: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ])
    , CareerExperiences: PropTypes.string
    , IndustryExperiences: PropTypes.string
};
